module.exports = __webpack_public_path__ + "media/images/icons/usuario-69f9f041bcd9ef535a7dfcba1c518d94.svg";